/**
 * Deduplicates concurrent in-flight GET requests.
 *
 * When multiple callers request the same key simultaneously, only one HTTP
 * request is made and all callers share its promise. Once the request settles
 * (success or failure), the next request for the same key makes a fresh call.
 */
const pending = new Map();

export function deduplicatedRequest(key, requestFn) {
  if (!pending.has(key)) {
    pending.set(
      key,
      requestFn().finally(() => pending.delete(key))
    );
  }
  return pending.get(key);
}
